let activeSessions = 0;
let sessionReleaseTimer: ReturnType<typeof setTimeout> | null = null;

const SESSION_SAFETY_MS = 120_000;

/** Mark that a native file/camera picker is open (dialog must stay mounted). */
export function beginNativeFilePickerSession(): void {
  if (sessionReleaseTimer) {
    clearTimeout(sessionReleaseTimer);
    sessionReleaseTimer = null;
  }
  activeSessions += 1;
  sessionReleaseTimer = setTimeout(() => {
    activeSessions = 0;
    sessionReleaseTimer = null;
  }, SESSION_SAFETY_MS);
}

export function endNativeFilePickerSession(): void {
  activeSessions = Math.max(0, activeSessions - 1);
  if (activeSessions === 0 && sessionReleaseTimer) {
    clearTimeout(sessionReleaseTimer);
    sessionReleaseTimer = null;
  }
}

export function isNativeFilePickerOpen(): boolean {
  return activeSessions > 0;
}
